import { ClientSettings } from "./models/static.interface";
import { environment } from "../../environments/environment";
declare var webSettings: ClientSettings;

export const clientSettings = {
    containerPlanningApiUri: environment.ContainerPlanningApiUri,
    authorizationToken: localStorage.getItem('token'),
    monitorAuthorizedUsers : environment.MonitorAuthorizedUsers
} as ClientSettings;
